import React, { useState } from "react";
import {
  HiOutlineChevronDown,
  HiOutlineWrench,
  HiOutlinePlus,
} from "react-icons/hi2";
import PmMatrixCell from "./PmMatrixCell";

const PmMatrixTable = ({ matrixData, onCellClick, onRespClick }) => {
  const [expandedPlans, setExpandedPlans] = useState({});

  const togglePlan = (planId) => {
    setExpandedPlans((prev) => ({
      ...prev,
      [planId]: !prev[planId],
    }));
  };

  const getPlanStats = (plan) => {
    let total = 0,
      scheduled = 0,
      completed = 0,
      overdue = 0;
    plan.tasks.forEach((task) => {
      total++;
      task.schedule.forEach((cell) => {
        if (cell.state === "Scheduled") scheduled++;
        if (cell.state === "Completed") completed++;
        if (cell.state === "Overdue") overdue++;
      });
    });
    return { total, scheduled, completed, overdue };
  };

  const formatFreq = (freq) => {
    if (!freq) return "";
    return freq.replace(/^1 (Months|Years|Days|Weeks)$/i, (match, p1) => {
      return `1 ${p1.slice(0, -1)}`;
    });
  };

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const currentMonthIdx = new Date().getMonth();

  return (
    <div className="matrix-table-scroll">
      <table className="matrix-table">
        <thead>
          <tr className="sticky-header">
            <th className="sticky-col first-col">Maintenance Task</th>
            <th className="sticky-col freq-col th-freq"> FREQUENCY</th>
            <th className="sticky-col resp-col th-resp">RESPONSIBILITY</th>
            {months.map((m, idx) => (
              <th
                key={m}
                className={`th-month th-month-${m} ${idx === currentMonthIdx ? "current-month" : ""}`}
              >
                {m}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {matrixData.map((plan) => {
            const planId = plan.planId || plan.maintenancePlanId;
            const isExpanded = expandedPlans[planId];
            const stats = getPlanStats(plan);

            return (
              <React.Fragment key={planId}>
                <tr className="plan-group-header">
                  <td
                    colSpan={months.length + 3}
                    className="sticky-col plan-group-header-cell"
                  >
                    <div
                      className="plan-badge-row cursor-pointer"
                      onClick={() => togglePlan(planId)}
                    >
                      <div className="header-left-v2">
                        <div className="icon-box-v2 chevron">
                          <HiOutlineChevronDown
                            className={isExpanded ? "" : "collapsed-icon"}
                          />
                        </div>
                        <div className="icon-box-v2 plan-icon">
                          <HiOutlineWrench />
                        </div>
                        <div className="header-titles-v2">
                          <div className="location-title-v2">
                            {plan.planName}
                          </div>
                          <div className="status-v2">
                            Type:{" "}
                            <span className="plan-type-badge">
                              Planned Maintenance
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="header-right-v2">
                        <div
                          className="summary-stats-v2"
                          style={{ borderRight: "none", paddingRight: 0 }}
                        >
                          <div className="stat-block-v2">
                            <span className="stat-label-v2">Total Tasks</span>
                            <span className="stat-value-v2">{stats.total}</span>
                          </div>
                          <div className="stat-block-v2">
                            <span className="stat-label-v2">Scheduled</span>
                            <span className="stat-value-v2">
                              {stats.scheduled}
                            </span>
                          </div>
                          <div className="stat-block-v2">
                            <span className="stat-label-v2">Completed</span>
                            <span className="stat-value-v2 completed">
                              {stats.completed}
                            </span>
                          </div>
                          <div className="stat-block-v2">
                            <span className="stat-label-v2">Overdue</span>
                            <span className="stat-value-v2 overdue">
                              {stats.overdue}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
                {isExpanded &&
                  plan.tasks.map((task) => (
                    <tr key={task.taskId} className="task-row">
                      <td className="sticky-col first-col task-name-cell">
                        <div className="task-name">{task.taskName}</div>
                      </td>
                      <td className="sticky-col freq-col task-freq">
                        {formatFreq(task.frequency)}
                      </td>
                      <td className="sticky-col resp-col task-resp">
                        <div
                          className="resp-badge-container"
                          onClick={() => onRespClick && onRespClick(plan, task)}
                          style={{ cursor: "pointer" }}
                        >
                          {task.responsible === "Not Assigned" ? (
                            <div className="unassigned-badge">
                              UNASSIGNED <span className="plus-icon">+</span>
                            </div>
                          ) : (
                            <div className="assigned-badge">
                              {task.responsible.includes("Mechanical") && "🔧 "}
                              {task.responsible.includes("Electrical") && "⚡ "}
                              {task.responsible.includes("Operator") && "👷 "}
                              {!task.responsible.includes("Mechanical") &&
                                !task.responsible.includes("Electrical") &&
                                !task.responsible.includes("Operator") &&
                                "🔧 "}
                              {task.responsible.replace(" Maintenance", "")}
                            </div>
                          )}
                        </div>
                      </td>
                      {task.schedule.map((cell, idx) => (
                        <td
                          key={idx}
                          className={`cell-wrapper ${
                            idx === currentMonthIdx ? "current-month-cell" : ""
                          }`}
                        >
                          <PmMatrixCell
                            cellData={{
                              ...cell,
                              month: months[idx],
                              year: plan.year || new Date().getFullYear(),
                            }}
                            task={task}
                            plan={plan}
                            onClick={() => onCellClick(plan, task, cell)}
                          />
                        </td>
                      ))}
                    </tr>
                  ))}
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default PmMatrixTable;
